import { type GetNotificationsResponseDto } from '@/common/types/notification';

import { api } from '../base';

type NotificationsQueryParams = {
  notReadOnly?: boolean;
  skip?: number;
  limit?: number;
};

const LIMIT = 30;

const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationsAll: builder.query<
      GetNotificationsResponseDto,
      NotificationsQueryParams
    >({
      query: (args) => {
        const params: Record<string, unknown> = {};
        params.skip = args.skip;
        params.take = typeof args.limit === 'undefined' ? LIMIT : args.limit;

        if (args?.notReadOnly !== undefined) {
          params['not-read-only'] = args.notReadOnly;
        }

        return {
          url: '/notification/all',
          method: 'GET',
          params,
        };
      },
    }),
    readAllNotifications: builder.mutation<void, void>({
      query: () => ({
        url: '/notification/read/all',
        method: 'POST',
      }),
    }),
    readNotificationById: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/notification/read/${id}`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetNotificationsAllQuery,
  useGetNotificationsAllQuery,
  useReadAllNotificationsMutation,
  useReadNotificationByIdMutation,
} = notificationsApi;
export { notificationsApi };
